import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import BoLoader from "../../helpers/BoLoader";
import DeclineTransactionGrid from "./DeclineTransactionGrid";
import DeclineAuthTransactionGrid from "./DeclineAuthTransactionGrid";
import ExportToExcel from "../superadmin/ExportToExcel";
const DeclineTransaction = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [refereshdata, setRefereshdata] = useState(false);
  //Loader
  const [boloader, setBoLoader] = useState(false);
  //ExportToExcel
  const [dataset, setDataset] = useState();
  //Transactions
  const [AllDeclinedClassName, setAllDeclinedClassName] = useState("nav-link active");
  const [NewDeclinedClassName, setNewDeclinedClassName] = useState("nav-link");
  const [AllDeclinedSelected, setAllDeclinedSelected] = useState("true");
  const [NewDeclinedSelected, setNewDeclinedSelected] = useState("false");
  useEffect(() => {
    setRefereshdata(true);
  }, []);
  const showAllDeclined = () => {
    setAllDeclinedClassName("nav-link active d-flex align-items-center");
    setAllDeclinedSelected("true");
    setNewDeclinedClassName("nav-link d-flex align-items-center");
    setNewDeclinedSelected("false");
  };

  const showNewDeclined = () => {
    setNewDeclinedClassName("nav-link active d-flex align-items-center");
    setNewDeclinedSelected("true");
    setAllDeclinedClassName("nav-link d-flex align-items-center");
    setAllDeclinedSelected("false");
  };

  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      {/* <h3>Stats</h3> */}
      <div className="row ">
        <BoLoader loading={boloader} />
       
      </div>
      <div className="bo-tabs-mbl">
        <ul className="nav nav-tabs" id="declineTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={AllDeclinedClassName}
              id="allDeclined-tab"
              data-bs-toggle="tab"
              data-bs-target="#allDeclined"
              type="button"
              role="tab"
              onClick={showAllDeclined}
              aria-controls="allDeclined"
              aria-selected={AllDeclinedSelected}
            >
              <span className="icon-decline"></span> Decline Transaction
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={NewDeclinedClassName}
              id="newDeclined-tab"
              data-bs-toggle="tab"
              data-bs-target="#newDeclined"
              type="button"
              role="tab"
              onClick={showNewDeclined}
              aria-controls="newDeclined"
              aria-selected={NewDeclinedSelected}
            >
              <span className="icon-decline"></span> Zero Auth Transactions
            </button>
          </li>
          <li className="nav-item ms-auto">
            <div className="toRight mt-16 mb-16">
              <ExportToExcel
                Dataset={dataset}
                Name="DeclineTransactions"
                calledfrom="declinetransactions"
              />
            </div>
            </li>
        </ul>
      </div>

      {
        AllDeclinedSelected === "true" && (
          <DeclineTransactionGrid
            methodname="getAllDeclines"
            placeholdervalue="Search Decline Transactions"
            headersdata={[
              "CLIENT NAME",
              "TOKEN ID",
              "CARD HOLDER",
              "COUNT",
              "CREATED DATE"
            ]}
            screenname="declinetransaction"
            refereshpage={setRefereshdata}
            status={"All"}
            setDataset={setDataset}
          />
        )
      }

      {
        NewDeclinedSelected === "true" && (
          <DeclineAuthTransactionGrid
            methodname="getNewDeclines"
            placeholdervalue="Search Auth Declines"
            headersdata={[
              "CLIENT NAME",
              "TOKEN ID",
              "CARD HOLDER",
              "AUTH COUNT",
              "CREATED DATE"
            ]}
            screenname="declinetransaction"
            refereshpage={setRefereshdata}
            status={"New"}
            setDataset={setDataset}
          />
        )
      }
     

    </div>
  );
};

export default DeclineTransaction;
